import { UrlBuilderUtils } from '../shared/url-builder-utils';
import { updateUrlParams } from '@services/MarppleShop/shared/util';

/**
 * 랭킹 타입 상태를 관리하는 매니저
 */
export class RankManager<TRankType extends string = string> {
  private rankType: TRankType;

  constructor(
    rankType: TRankType | undefined,
    private readonly defaultRankType: TRankType,
  ) {
    // 값이 없으면 기본값으로 초기화
    this.rankType = rankType ?? defaultRankType;
  }

  setRankType(rankType: TRankType): this {
    this.rankType = rankType;
    return this;
  }

  getRankType(): TRankType {
    return this.rankType;
  }

  isDefault(): boolean {
    return this.rankType === this.defaultRankType;
  }

  /**
   * 랭킹 페이지 URL 생성
   */
  buildRankingUrl(baseUrl: string): string {
    const params = UrlBuilderUtils.buildRankingParams(this.rankType, this.defaultRankType);
    return updateUrlParams(baseUrl, params);
  }

  reset(): this {
    this.rankType = this.defaultRankType;
    return this;
  }
}
